import { useInitiateAuthMutation } from 'apollo/queries/autogenerate/hooks-public';
import {
  PinCodeDispatchMethod,
  Platform,
} from 'apollo/queries/autogenerate/schemas-public';
import { getParsedPhoneNumber } from 'shared/utils/phone';

type Props = {
  email: string;
  phone: string;
  method: PinCodeDispatchMethod;
  reCaptchaPlatform: Platform;
  reCaptchaToken: string;
};

type InitiateAuthData = {
  __typename: string;
  session: string;
};

const useInitiateAuth = () => {
  const [initiateAuthMutation] = useInitiateAuthMutation({
    context: {
      uri: process.env.CONSUMER_API_HOST_GRAPHQL_PUBLIC,
    },
  });

  const initiateAuth = (props: Props) => {
    return new Promise<string>(async (resolve, reject) => {
      try {
        const result = await initiateAuthMutation({
          variables: {
            email: props.email,
            phone: getParsedPhoneNumber(props.phone),
            pinCodeDispatchMethod: props.method,
            recaptchaPlatform: props.reCaptchaPlatform,
            recaptchaToken: props.reCaptchaToken,
          },
        });

        resolve((result.data?.initiateAuth as InitiateAuthData).session);
      } catch (err) {
        reject(err);
      }
    });
  };

  return initiateAuth;
};

export default useInitiateAuth;
